import { Route, Routes } from "react-router-dom";
import "./App.css";
// import Home from "./pages";
// import AjmalAccount from "./pages/ajmal";
import QuotationBuilder from "./pages/quotation";
// import MeghaResume from "./pages/megha";
import LoginWrapper from "./components/LoginWrapper";

function App() {
  return (
    <LoginWrapper>
      <Routes>
        <Route path="/" element={<QuotationBuilder />} />
        {/* <Route path="ajmal" element={<AjmalAccount />} /> */}
        {/* <Route path="/quotation" element={<QuotationBuilder />} /> */}
        {/* <Route path="/megha" element={<MeghaResume />} /> */}
      </Routes>
    </LoginWrapper>
  );
}

export default App;
